import InternalLayoutPanel, {
  Content,
  ContentContainer,
  Header,
  LeftSideBar,
  RightSideBar,
} from './LayoutPanel';

type TInternalLayoutPanel = typeof InternalLayoutPanel;

type CompoundedComponent = TInternalLayoutPanel & {
  Header: typeof Header;
  ContentContainer: typeof ContentContainer;
  LeftSideBar: typeof LeftSideBar;
  RightSideBar: typeof RightSideBar;
  Content: typeof Content;
};

const LayoutPanel = InternalLayoutPanel as CompoundedComponent;

LayoutPanel.Header = Header;
LayoutPanel.ContentContainer = ContentContainer;
LayoutPanel.LeftSideBar = LeftSideBar;
LayoutPanel.RightSideBar = RightSideBar;
LayoutPanel.Content = Content;

export default LayoutPanel;
